import { Set, List } from 'immutable';
import { select, call, put } from 'redux-saga/effects';
import { actions } from '@groove-labs/groove-ui';
import { getSearchParams } from 'Modules/Shared/selectors/location';
import { LABEL_IDS_TO_FILTER_UI_KEY_PATH } from 'Modules/Shared/constants/labels';
import { getCombinedLabels } from 'Modules/Shared/selectors/labels';
import {
  get as getStoredCheckedLabelIds,
  set as setLabelIdsInLocalStore,
} from 'Modules/Shared/localStorage/checkedLabelIds';

const { setProperty } = actions.ui;

// labels are shared across modules, so it is in UI reducer

function* getLabelIdsFromSearchParams() {
  const searchParams = yield select(getSearchParams);
  if (searchParams.has('filteredLabelIds')) {
    const labelIds = searchParams.get('filteredLabelIds');
    if (List.isList(labelIds)) {
      return labelIds.map(id => parseInt(id, 10));
    }
    return new List([parseInt(labelIds, 10)]);
  }
  return new List();
}

function getLabelIdsFromLocalStore(moduleName) {
  const storedIds = getStoredCheckedLabelIds(moduleName);
  return new List(storedIds);
}

function* handleFilterLabelsUpstart(moduleName, hasStickyLabels = false) {
  let ids = yield call(getLabelIdsFromSearchParams);

  if (hasStickyLabels) {
    const idsFromLocalStore = getLabelIdsFromLocalStore(moduleName);
    ids = ids.concat(idsFromLocalStore);

    const allLabels = yield select(getCombinedLabels);

    // Confirm that all labels still exist before we proceed
    ids = ids.reduce((confirmedLabelIds, id) => {
      if (allLabels.has(id)) {
        return confirmedLabelIds.push(id);
      }
      return confirmedLabelIds;
    }, new List());

    yield call(setLabelIdsInLocalStore, { moduleName, ids: new Set(ids) });
  }

  yield put(
    setProperty({
      uiKeyPath: LABEL_IDS_TO_FILTER_UI_KEY_PATH,
      data: new Set(ids),
    })
  );
}

export default handleFilterLabelsUpstart;
